export enum HeaderTypes {
    Liquidity = "Liquidity",
    Bets = "Bets"
}